import {
  CUSTOMER_ORDER_ACTIVE_STATUS_VALUES,
  CUSTOMER_ORDER_STATUS_VALUES,
  type ActiveCustomerOrderStatus,
  type OrderStatus,
} from '../../types/order';

export {
  CUSTOMER_ORDER_ACTIVE_STATUS_VALUES,
  CUSTOMER_ORDER_STATUS_VALUES,
};
export type CustomerOrderStatus = OrderStatus;
export type { ActiveCustomerOrderStatus };

export const getOrderAllowedTransitions = (order?: {
  allowedTransitions?: string[];
} | null): CustomerOrderStatus[] => {
  if (!order) {
    return [];
  }

  if (Array.isArray(order.allowedTransitions)) {
    return order.allowedTransitions.filter(isCustomerOrderStatus);
  }

  return [];
};

export const isCustomerOrderStatus = (status: string): status is CustomerOrderStatus => (
  CUSTOMER_ORDER_STATUS_VALUES.includes(status as CustomerOrderStatus)
);

export const isActiveCustomerOrderStatus = (status: string): status is ActiveCustomerOrderStatus => (
  CUSTOMER_ORDER_ACTIVE_STATUS_VALUES.includes(status as ActiveCustomerOrderStatus)
);

// Statuses reached before the customer has confirmed the order (pipeline
// NEW_INQUIRY -> QUOTE_SENT -> CONFIRMED). Single home for "is this order still pre-confirmation" so callers
// (e.g. the transport form's non-blocking unconfirmed-order warning) never
// reimplement the status set locally. This does NOT gate any permission or
// action — OPERATIONS keeps full transport create/edit ability regardless of
// the linked order's status; it only drives an informational warning.
const PRE_CONFIRMATION_ORDER_STATUSES: readonly CustomerOrderStatus[] = [
  'NEW_INQUIRY',
  'QUOTE_SENT',
];

export const isPreConfirmationOrderStatus = (status: string): boolean => (
  PRE_CONFIRMATION_ORDER_STATUSES.includes(status as CustomerOrderStatus)
);
